export default {"src":"/_next/static/image/public/images/flags/flag_262.be3d99f293de5d5dd233d0f90be04acd.svg","height":16,"width":24};